module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Natalie  Goldberg\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Natalie Goldberg")]), _vm._v(" (b. 1948) is the author of ten books, including "), _c('I', [_vm._v("Writing Down the Bones")]), _vm._v(", which has sold over one million copies and has been translated into fourteen languages. She has also written the beloved "), _c('I', [_vm._v("Long Quiet Highway: Waking Up in America")]), _vm._v(", a memoir about her Zen teacher. For the past thirty years she has practiced Zen and taught seminars on writing as a spiritual practice. She lives in northern New Mexico.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uVlR95/images/backcover.jpg?1690317051131",
      "alt": "This image is the cover for the book Living Color"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Living Color\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Essays, art, and exercises with “many gems that will brighten anyone’s fearful mind,” from the author of the creativity classic "), _c('i', [_vm._v("Writing Down the Bones")]), _vm._v(" ("), _c('i', [_vm._v("The Taos News")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Known as an author and sought-after writing teacher, Natalie Goldberg is also a painter whose work has been shown widely and included in prominent collections. In "), _c('i', [_vm._v("Living Color")]), _vm._v(", she expounds on her own path to artistic inspiration, and reminds us that our explorations are not limited to only one form. Tailored to a new generation of readers who want to draw, paint, write, or express themselves through some other creative medium, this revised and expanded edition features thirteen of Natalie Goldberg’s engaging and encouraging essays with seventy-five of her paintings and twenty-two never-before-shared artistic exercises. "), _c('br'), _c('br'), _vm._v("A work of beauty and inspiration, "), _c('i', [_vm._v("Living Color")]), _vm._v(" speaks straight to the heart of anyone who wants to break down creative barriers or explore their creativity anew.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Abrams\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0